module.exports = __webpack_public_path__ + "static/media/calendar.6ef563a8.svg";